// Copyright 2019 Sorama B.V.

import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";
import * as LZString from "lz-string";
import { UnitParser as Parser } from "units/UnitParser";
import { UnitSystem } from "units/UnitSystem";

export class UnitSystemParser implements IWorkflowPropertyParser<UnitSystem> {
    toWorkflowProperty(object: UnitSystem): string {
        if (!object) {
            return "";
        }

        const objectString = JSON.stringify(object);
        return LZString.compressToBase64(objectString);
    }

    fromWorkflowProperty(str: string): UnitSystem {
        if (!str || typeof str !== "string") {
            return UnitSystem.Metric;
        }

        // Decompress from base64 string
        const decompressed = LZString.decompressFromBase64(<string>str);
        if (!decompressed) {
            return UnitSystem.Metric;
        }

        const object = JSON.parse(decompressed);
        const unitSystem = new UnitSystem();

        for (const property in object) {
            if (Object.prototype.hasOwnProperty.call(object, property)) {
                switch (property) {
                    case "name":
                        (<UnitSystem>unitSystem)[property] = <string>(<unknown>object)[property];
                        break;
                    case "distance":
                    case "pressure":
                    case "flow":
                    case "currency":
                    case "flowEffort":
                    case "weight":
                        (<UnitSystem>unitSystem)[property] = Parser.Parse((<unknown>object)[property]._unit);
                        break;
                    default:
                        console.error(property + " is not supported by the UnitSystemParser");
                }
            }
        }

        return unitSystem;
    }
}
